import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledWrapper = styled.div`
	height: 100%;
	transition: opacity 0.3s ease;
	&.app-enter {
		opacity: 0;
	}

	&.app-enter-active,
	&.app-enter-done,
	&.app-exit {
		opacity: 1;
	}

	&.app-exit-active {
		opacity: 0;
	}
`;

const StyledContainer = styled.div`
	height: 100%;
	padding-top: 49px;
	background-color: #111111;
	transition: opacity 0.3s ease;
	&.loading-enter {
		opacity: 0;
	}

	&.loading-enter-active,
	&.loading-enter-done,
	&.loading-exit {
		opacity: 1;
	}

	&.loading-exit-active {
		opacity: 0;
	}
`;

const StyledLayoutContainer = styled.div<{ $compact?: boolean }>`
	display: grid;
	grid-template-columns: 240px 1fr;
	height: 100%;
	border-top: 1px solid rgba(255, 255, 255, 0.1);
	transition: grid-template-columns 0.3s ease;
	will-change: grid-template-columns;

	${({ $compact }) =>
		$compact
			? css`
					grid-template-columns: 80px 1fr;

					${StyledLeftContainer} {
						width: 80px;
					}

					${StyledAppTitleContainer} {
						div {
							opacity: 0;
						}
					}

					${StyledMenuItem} {
						padding: 0 10px 0 13px;

						${Text} {
							opacity: 0;
						}
					}
			  `
			: css`
					grid-template-columns: 240px 1fr;

					${StyledLeftContainer} {
						width: 240px;
					}

					${StyledMenuItem} {
						padding: 0 10px;
					}
			  `}
`;

const StyledLeftContainer = styled.div`
	padding: 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border-right: 1px solid rgba(255, 255, 255, 0.1);
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

const StyledMenuTop = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledAppTitleContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		width: 40px;
		height: 40px;
		user-select: none;
		pointer-events: none;
	}

	div {
		overflow: hidden;
		white-space: nowrap;
		transition: opacity 0.3s ease;

		.title {
			font-style: italic;
			font-weight: 700;
			font-size: 16px;
			color: #1ab248;
		}

		.text {
			font-weight: 400;
			font-size: 10px;
			color: #ffffff;
			opacity: 0.5;
		}
	}
`;

const StyledMenuContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const StyledMenuItem = styled.div<{ $active?: boolean }>`
	display: flex;
	align-items: center;
	gap: 10px;
	width: 100%;
	height: 40px;
	border-radius: 10px;
	padding: 0 10px;
	transition: background-color 0.3s ease;
	cursor: pointer;
	overflow: hidden;
	will-change: padding;

	img {
		width: 14px;
		height: 14px;
		user-select: none;
		pointer-events: none;
		opacity: 0.5;
		transition:
			filter 0.3s ease,
			opacity 0.3s ease;
	}

	${Text} {
		font-weight: 400;
		font-size: 14px;
		transition:
			color 0.3s ease,
			opacity 0.3s ease;
		white-space: nowrap;
		color: rgba(255, 255, 255, 0.5);
	}

	${(props) =>
		props.$active &&
		css`
			background-color: #1ab248;

			img {
				opacity: 1;
				filter: invert(0);
			}

			${Text} {
				color: #ffffff;
			}
		`}

	&:hover {
		background-color: #ffffff;

		img {
			opacity: 1;
			filter: invert(100%);
		}

		${Text} {
			color: #000000;
		}
	}
`;

const StyledGroupItem = styled(StyledMenuItem)<{ $active?: boolean }>`
	background-color: #2d70da;

	${({ $active }) =>
		$active &&
		css`
			background-color: #1ab248;
		`}

	img {
		opacity: 1;
	}
`;

const StyledExitButton = styled(StyledMenuItem)`
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);

	${Text} {
		color: #ffffff;
	}
`;

const StyledMenuBottom = styled.div`
	display: flex;
	flex-direction: column;
	gap: 40px;
`;

export {
	StyledAppTitleContainer,
	StyledContainer,
	StyledExitButton,
	StyledGroupItem,
	StyledLayoutContainer,
	StyledLeftContainer,
	StyledMenuBottom,
	StyledMenuContainer,
	StyledMenuItem,
	StyledMenuTop,
	StyledWrapper,
};
